// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + ({"300":"todo","363":"clinics","443":"about","557":"parts","571":"settings","992":"reports"}[chunkId] || chunkId) + "." + {"300":"53f2b147","363":"89f12e22","443":"48f16555","481":"2f52c2d2","557":"ddb4d1fc","571":"0765378e","992":"9e6ecb1e"}[chunkId] + ".js";
};